var string = {}

string.escapeReg = function (str) {
  return str.replace(new RegExp('([.*+?^=!:\x24{}()|[\\]/\\\\])', 'g'), '\\$1')
}

string.htmlEncode = function (str) {
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ /g, '&#32;')
}

string.htmlDecode = function (str) {
  return str.replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#32;/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
}

export default string



// WEBPACK FOOTER //
// ./src/utils/util.string.js